<template>
    <div style="max-width:1200px; margin: auto;" class="pa-3">
        <h3 id="titulo"></h3>
        <CustomAlert  type="warning" class="mb-2" style="width:100%">
            <template v-slot:icon>
              !
            </template>
            <strong>IMPORTANTE:</strong>&nbsp;Antes de definir el correo electrónico para notificaciones, debe asegurarse de tener acceso al correo para poder acceder al enlace de confirmación del correo que se le enviará y poder continuar con el proceso de solicitud. Este correo podrá ser cambiado más adelante cuando se le otorgue las credenciales a la plataforma.
          </CustomAlert>
        <v-spacer class="hide-on-mobile" />
        <v-form ref="formNit" v-model="formNit" lazy-validation @submit.prevent="guardarDatos">
            <v-layout row wrap>
                <v-flex xs11>
                    <v-text-field v-model="correo" label="Correo electrónico" :rules="[validarCampo]" maxlength="50"
                        counter="50" rows="2" />
                </v-flex>
                <v-flex xs1>
                    <transition name="transition-opacity">
                        <div>
                            <GlobalCardToolTip prependIcon="info" iconColor="amber" width="460px" iconSize="24px">
                                <template #contenido>
                                    <span>{{ ContenidoInformacion }}</span>
                                </template>
                            </GlobalCardToolTip>
                        </div>
                    </transition>
                </v-flex>
                <!-- Centering the captcha and button -->
                <v-layout column align-center>
                    <v-flex>
                        <vue-recaptcha ref="recaptcha" class="ma-10" sitekey="6LcI_mcUAAAAAAebiEZL4LhF1JcGDJqzI1kQ71b2"
                            @verify="onVerify" @expired="onExpired" />
                    </v-flex>
                    <v-flex>
                        <v-btn v-show="respuestaCaptcha" color="success" outline round dark type="submit">
                            <v-icon>send</v-icon>&nbsp;&nbsp;&nbsp;Enviar
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import types from '@/store/types/SolicitudCredenciales'
import VueRecaptcha from "vue-recaptcha";
import GlobalCardToolTip from '../Global/GlobalCardToolTip.vue';
import CustomAlert from "@/components/CustomAlert.vue";


export default {
    components: {
        VueRecaptcha,
        GlobalCardToolTip,
        CustomAlert,
    },
    data() {
        return {
            formNit: false,
            correo: "",
            respuestaCaptcha: false,
            ContenidoInformacion: "",
            tituloCorreo:"",
            subtitulo:"",
        }
    },
    mounted() {
        this.ContenidoInformacion = `El correo electrónico que registrara será el correo principal de envió de notificaciones e información de PAJEL. Asegúrese de tener acceso al correo que esta registrando, porque se le enviara un enlace de verificación para continuar con su solicitud. Una vez aceptada su solicitud, se le enviará la confirmación de habilitación al correo que registró.`
        this.tituloCorreo = document.getElementById("titulo")
        this.subtitulo = document.getElementById("subtitulo")
        this.tituloCorreo.innerHTML = "<p><strong>Antes de empezar:</strong> Primero define un correo válido para recibir las notificaciones de la plataforma.</p>"
        },

    methods: {
        async guardarDatos() {
            const isValid = await this.$refs.formNit.validate();
            if (isValid) {
                this.EnvioDeSolicitud(this.correo).then(res => {
                })
            }
        },
        validarCampo(value) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!value) return 'El correo electrónico es obligatorio.';
            if (!regex.test(value)) return 'El correo electrónico no es válido.';
            return true;
        },
        onVerify(response) {

            this.respuestaCaptcha = true
        },
        onExpired() {
            this.resetRecaptcha();
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
            this.respuestaCaptcha = false;
        },
        ...mapMutations({
            SetDatosSin: types.mutations.SetDatosSin,
        }),
        ...mapActions({
            BuscarYRegistrarDatosSin: types.actions.BuscarYRegistrarDatosSin,
            EnvioDeSolicitud: types.actions.EnvioDeSolicitud,
        }),

    },

    computed: {
        ...mapGetters({
            GetDatosSin: types.getters.GetDatosSin
        }),
        objDatosSin: {
            get() {
                return this.GetDatosSin;
            },
            set(value) {
                this.SetDatosSin(value);
            }
        }
    }
}

</script>
